// TODOS
// 1. clear the session token during application logout
// 	a. what is tr-auth-token? who sets it and when is it invalidated
import { Component, OnInit, OnDestroy, ChangeDetectionStrategy, ChangeDetectorRef,
	ViewChild, TemplateRef, ElementRef, AfterViewInit } from '@angular/core';
import { getRoute } from '@onviobr/services/environment';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';

import { MigrationDetailsService, MigrationStatusType } from '../migration-details/migration-details.service';
import { NetClientMigration } from '../migration-products/netclient-migration';
import { BentoTransferboxColumnDefinitions } from '@bento/bento-ng-transferbox';
import { MigrationService } from '../migration-service/migration.service';
import { catchError } from 'rxjs/internal/operators/catchError';
import { of } from 'rxjs/internal/observable/of';
import { BentoAlertItemOptions } from '@bento/bento-ng';
import { HttpHeaders } from '@angular/common/http';

import { getBindings, getMeta } from '@onviobr/services/session';
import { MigrationEvent, MigrationEventPayload } from '../migration-event/migration-event';
import { MigrationResult, InitMigrationResponse } from '../migration-result/migration-result';

import * as wjcCore from '@grapecity/wijmo';
import { TranslateService } from '@ngx-translate/core';
import { has } from '@onviobr/services/permission';
import { DateTimeService } from '../migration-date-time/date-time.service';
import { MigrationSource } from '../migration-reusable-components/migration-source.enum';
import { trackAlert } from '@onviobr/pendo-global';
import { NetClientPortal } from './net-client-portal';
import { MigrationConstants } from '../migration-reusable-components/migration-constants';

const { IN_PROGRESS, COMPLETED } = MigrationStatusType;

declare const trAuth: any;

const trAuthConfig = async (wrapper: HTMLElement, _getRoute: typeof getRoute) => ({
	title: 'NetClient migrations start from Onvio.',
	type: 'netfirm',
	sp: 'netfirm',
	locale: 'en-US',
	targetElem: wrapper,
	insertPosition: 'afterbegin',
	templateData: {
		authSvcHost: (await _getRoute('AuthenticationAggregatorServices').catch ( () => '' )).replace('/api/auth', ''),
	},
	formOverrides: {
		'trta1-signin': {
			types: {
				uid: 'text'
			}
		}
	}
});
@Component({
	selector: 'app-netclient-migration',
	templateUrl: './netclient-migration.component.html',
	styleUrls: ['./netclient-migration.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush
})

export class NetclientMigrationComponent implements OnInit, AfterViewInit, OnDestroy {
	loginModal: NgbModalRef;
	productInfo: NetClientMigration;
	readonly migrationSource = MigrationSource.NETFIRM;
	readonly PREPARE_FOR_MIGRATION_LINK = MigrationConstants.PREPARE_FOR_MIGRATION_LINK;
	readonly NETCLIENT_TO_ONVIO_LINK = 'https://onvio.us/ua/help/us-en/staff/core/migrations/netclient-to-onvio.htm';
	companyId: string;
	hasServerError = false;
	// assign for testing purposes
	public getRoute = getRoute;
	public hasPermission = has;
	public getBindings = getBindings;
	public getMeta = getMeta;

	netFirmRootUrl: string;
	getClientPortalsUrl = '/rest/admin/netclient_users/all';
	postMigrationEventUrl = '/api/migration-orchestrator/v2/migrations';
	migrationResultsUrl = '/api/migration-orchestrator/v1/results?companyId';

	makeFooterSticky: boolean;

	@ViewChild('netclientHeading', {static: true}) netclientHeading: ElementRef;
	@ViewChild('trAuthContent', {static: true}) trAuthContent: TemplateRef<any>;
	@ViewChild('trAuthContainer', { static: true }) trAuthContainer: ElementRef;

	@ViewChild('migrationFooter', {static: false}) set migrationFooterEl(migrationFooter: ElementRef) {
		if (migrationFooter) {
			if (migrationFooter.nativeElement.offsetTop > document.body.clientHeight) {
				this.makeFooterSticky = true;
			}
		}
	}

	private transferbox: any;
	toolTip: wjcCore.Tooltip = new wjcCore.Tooltip({
		showAtMouse: true,
		cssClass: 'migration-transferbox-tooltip'
	});
	@ViewChild('transferbox', {static: false}) set transferBoxComponent(tbComponent: any) {
		if (tbComponent) { // initially setter gets called with undefined
			this.transferbox = tbComponent;

			const boxOneGrid = this.transferbox.boxOne.flexGrid;
			boxOneGrid.hostElement.addEventListener('mouseover', this.showTooltip(boxOneGrid));
			boxOneGrid.hostElement.addEventListener('mouseout', this.hideTooltip());

			const boxTwoGrid = this.transferbox.boxTwo.flexGrid;
			boxTwoGrid.hostElement.addEventListener('mouseover', this.showTooltip(boxTwoGrid));
			boxTwoGrid.hostElement.addEventListener('mouseout', this.hideTooltip());
			this.applyBoxOneGridFilterDefinition();
		}
	}

	@ViewChild('completedMigrationBanner', { static: false }) completedMigrationBanner: TemplateRef<any>;


	availablePortals: Array<NetClientPortal> = [];
	selectedPortals: Array<NetClientPortal>;
	gridOptions: BentoTransferboxColumnDefinitions[] = [];
	hidePagination = false;
	hideFilters = false;
	gridHeight = 600;
	dataLoaded = false;
	showTransferBox = false;
	previouslySelectedPortalCount = 0;

	alerts: BentoAlertItemOptions[] = [];
	inlineAlerts: BentoAlertItemOptions[] = [];

	LOGIN_TOKEN_NAME = 'NETFIRM_TOKEN';
	LOGIN_TOKEN_EXPIRY = 'NETFIRM_TOKEN_EXPIRY';

	migrationEvent: MigrationEvent;
	showBusyloaderMigrateSelected: boolean;
	migrationResult: [any];
	migrationInprogress: Array<MigrationResult>;
	migrationCompleted: Array<MigrationResult>;
	showMigrationResultsBusyLoader: boolean;

	constructor(
		private migrationDetails: MigrationDetailsService,
		private modalService: NgbModal,
		private dateTimeService: DateTimeService,
		private changeDetectorRef: ChangeDetectorRef,
		private migrationService: MigrationService,
		private translate: TranslateService) {
		this.onTRAuthSuccess = this.onTRAuthSuccess.bind(this);
		this.productInfo = new NetClientMigration();
	}

	async ngOnInit() {
		this.netFirmRootUrl = await this.getRoute('NetFirmRoot');

		await this.getSessionBindings();
		this.setMigrationResult();
	}

	ngAfterViewInit() {
		window.addEventListener('scroll', this.scrollHandler.bind(this));
	}

	ngOnDestroy() {
		window.removeEventListener('scroll', this.scrollHandler.bind(this));
		this.migrationDetails.productMigrationStateMap.set(this.migrationSource, this.productInfo);
	}

	scrollHandler() {
		// for sticky footer: https://medium.com/@elad/css-position-sticky-how-it-really-works-54cd01dc2d46
		const stickyState = this.makeFooterSticky;
		if ((window.innerHeight + window.pageYOffset) >= document.body.scrollHeight) {
			this.makeFooterSticky = false;
		} else {
			this.makeFooterSticky = true;
		}

		// if the state is changed, markForCheck
		if (stickyState !== this.makeFooterSticky) {
			this.changeDetectorRef.markForCheck();
		}
	}

	setMigrationResult() {
		this.migrationInprogress = this.migrationDetails.getCachedMigrationResults(this.migrationSource, IN_PROGRESS);
		this.migrationCompleted = this.migrationDetails.getCachedMigrationResults(this.migrationSource, COMPLETED);
		this.changeDetectorRef.markForCheck();
	}

	updateInProgressMigrationStatus(event: Array<MigrationResult>) {
		if (event?.length) {
			this.migrationInprogress = event;
		} else {
			this.migrationInprogress = null;
		}
	}

	sendRegistrations(index: number) {
		this.inlineAlerts.splice(index, 1);
		window.location.href = '/staff/#/setup/migrations/client-registration';
	}

	showLastCompletedMigration(event: MigrationResult) {
		if (event) {
			const formattedDateTime = this.dateTimeService.getDateTimeFromUnixTimestamp(event.migrationStartDate).split(' ');
			const completedDate = formattedDateTime[0].split('');
			completedDate.splice(completedDate.length - 4, 2);
			this.inlineAlerts.push({
				type: 'success',
				template: this.completedMigrationBanner,
				data: {
					// MM/DD/YY
					date: completedDate.join(''),
					// hh:mm AM/PM
					time: `${formattedDateTime[1]} ${formattedDateTime[2]}`,
				},
				closeable: true,
			});
		}
	}

	toggleFilters() {
		this.hideFilters = !this.hideFilters;
	}

	toggleAvailable() {
		// get transferbox control,
		// you'll have access to boxOne and boxTwo,
		// and call method toggleAll()
		this.transferbox.boxOne.toggleAll();
	}

	onTransfer($event) {
		this.selectedPortals = $event.gridDataTwo;

		if (this.selectedPortals.length > this.previouslySelectedPortalCount) {
			this.showMessage(
				this.translate.instant('onvio.setup.migrations.netfirm.addedPortals',
					{ portalCount: this.selectedPortals.length - this.previouslySelectedPortalCount }), 'info');
		} else if (this.selectedPortals.length < this.previouslySelectedPortalCount) {
			this.showMessage(
				this.translate.instant('onvio.setup.migrations.netfirm.removedPortals',
					{ portalCount: this.previouslySelectedPortalCount - this.selectedPortals.length }), 'info');

		}

		this.previouslySelectedPortalCount = this.selectedPortals.length;
		if (this.transferbox) {
			setTimeout( () => {
				this.applyBoxOneGridFilterDefinition();
			});
		}
	}

	showMessage(msg: any, type: string) {
		this.alerts = [];
		trackAlert(type, msg);
		this.alerts.push({
			closeable: true,
			msg,
			type,
		});
	}

	migrateSelected() {
		this.showBusyloaderMigrateSelected = true;
		const payLoad: Array<MigrationEventPayload> = this.createMigrationEventPayload(this.selectedPortals);
		if (payLoad?.length < 1) {
			console.error('Couldn\'t generate payload');
		}
		this.migrationEvent.metadata = {
			netfirmToken: window.sessionStorage.getItem(this.LOGIN_TOKEN_NAME)
		};
		this.migrationEvent.payload = {
			clientsInfo: payLoad
		};
		this.postMigrationEvent();
	}

	hideTransferBox() {
		this.selectedPortals = [];
		this.previouslySelectedPortalCount = 0;
		this.showTransferBox = false;
		this.expandTransferboxToFullWidth(false);
	}

	/*********** TR-AUTH related - START ***********/
	public async onTRAuthSuccess(event: any) {
		window.removeEventListener('tr-auth-success', this.onTRAuthSuccess);
		window.sessionStorage.setItem(this.LOGIN_TOKEN_NAME, event.detail.data.token);
		window.sessionStorage.setItem(this.LOGIN_TOKEN_EXPIRY, event.detail.data.decodedToken.exp);
		// this.tokenExpiration = event.detail.data.decodedToken.exp;

		if (this.loginModal) {
			this.loginModal.close();
		}
		this.initTransferBox();
		this.changeDetectorRef.markForCheck();
	}

	async openLoginModal(trContent) {
		this.loginModal = this.modalService.open(trContent,
			{container: this.trAuthContainer.nativeElement as HTMLElement, ariaLabelledBy: 'modal-basic-title' });

		await new Promise(resolve => setTimeout(resolve, 100));
		this.openTrAuth();
	}

	async openTrAuth() {
		const loginContainerEl: HTMLElement = document.querySelector('.login-tr-auth');
		trAuth.modules.auth.init(await trAuthConfig(loginContainerEl, this.getRoute));
		window.addEventListener('tr-auth-success', this.onTRAuthSuccess);
	}
	/*********** TR-AUTH related - END ***********/


	async choosePortals(trContent) {
		const clientDocumentsPermission = await this.hasPermission('OnvioDrive.ClientDocuments');
		if (!clientDocumentsPermission) {
			const warningMessage = this.translate.instant('onvio.setup.migrations.netfirm.noClientDocumentsPermission.warning');
			this.showError(warningMessage);
			this.changeDetectorRef.markForCheck();
			return;
		}

		// show the login screen, if the token is not present or the token expired
		if (this.needsLogin()) {
			await this.openLoginModal(trContent);
		} else {
			this.initTransferBox();
		}
	}

	private initTransferBox() {
		this.showTransferBox = true;
		if (this.dataLoaded) {
			this.expandTransferboxToFullWidth(true);
			return;
		}
		const headers = new HttpHeaders({
			'Content-Type': 'application/json',
			Authorization: `Bearer ${window.sessionStorage.getItem(this.LOGIN_TOKEN_NAME)}`
		});
		this.migrationService
			.get(this.netFirmRootUrl + this.getClientPortalsUrl, headers)
			.pipe(
				catchError(err => {
					console.error(err);
					const errorMessage = this.translate.instant('onvio.setup.migrations.netfirm.http.error',
						{ action: 'list of NetClient users', error: err });
					this.showError(errorMessage);
					this.hideTransferBox();
					this.changeDetectorRef.markForCheck();
					return of([]);
				})
			).subscribe( (clientList: any) => {
				const portalsCount = clientList?.Users?.length;
				if (portalsCount) {
					this.displayPortals(clientList.Users);
					this.expandTransferboxToFullWidth(true);
					this.dataLoaded = true;
					this.changeDetectorRef.markForCheck();
				} else if (portalsCount === 0) {
					this.hideTransferBox();
					const errorMessage = this.translate.instant('onvio.setup.migrations.netfirm.zeroportals.error');
					this.showError(errorMessage);
					this.logoutFromNetfirm();
					this.changeDetectorRef.markForCheck();
				}
			});

		this.selectedPortals = [];
		this.gridOptions = [
			{
				header: 'id',
				binding: 'id',
				visible: false,
				minWidth: 100
			},
			{
				header: 'Name',
				binding: 'DisplayName',
				visible: true,
				allowSorting: true,
				allowDragging: true,
				isReadOnly: false,
				isRequired: false,
				minWidth: 100,
				width: '*',
				filter: {
					type: 'input'
				}
			},
			{
				header: 'Email',
				binding: 'emailId',
				visible: true,
				allowSorting: true,
				allowDragging: true,
				isReadOnly: false,
				isRequired: false,
				minWidth: 150,
				width: '*',
				filter: {
					type: 'input'
				}
			},
			{
				header: 'Login',
				binding: 'Login',
				visible: true,
				allowSorting: true,
				allowDragging: true,
				isReadOnly: true,
				isRequired: false,
				minWidth: 50,
				width: '*',
				filter: {
					type: 'input'
				}
			},
			{
				header: 'Registered',
				binding: 'registrationInfo',
				visible: true,
				allowSorting: true,
				allowDragging: true,
				isReadOnly: false,
				isRequired: false,
				minWidth: 25,
				width: '*',
				filter: {
					type: 'input'
				}
			}
			, {
				header: 'Migrated',
				binding: 'migrationInfo',
				visible: true,
				allowSorting: true,
				allowDragging: true,
				isReadOnly: false,
				isRequired: false,
				minWidth: 50,
				width: '*',
				filter: {
					type: 'input'
				}
			},
			{
				header: 'Last login',
				binding: 'lastLoginReadableTime',
				visible: false,
				allowSorting: true,
				allowDragging: true,
				isReadOnly: false,
				isRequired: false,
				minWidth: 50,
				width: '*',
				filter: {
					type: 'input'
				}
			}
		];
	}

	private needsLogin(): boolean {
		return this.isNetfirmTokenMissing() || this.isNetfirmTokenExpired();
	}

	isNetfirmTokenMissing(): boolean {
		return !window.sessionStorage.getItem(this.LOGIN_TOKEN_NAME);
	}

	isNetfirmTokenExpired(): boolean {
		const currentTimestampInSeconds = new Date().getTime() / 1000;
		return this.getNetfirmTokenExpiration() < currentTimestampInSeconds;
	}

	getNetfirmTokenExpiration(): number {
		return Number(window.sessionStorage.getItem(this.LOGIN_TOKEN_EXPIRY));
	}

	logoutFromNetfirm() {
		window.sessionStorage.removeItem(this.LOGIN_TOKEN_NAME);
		window.sessionStorage.removeItem(this.LOGIN_TOKEN_EXPIRY);
	}

	private displayPortals(users: Array<NetClientPortal>): void {
		for (const user of users) {
			if (user.migrated) {
				// Display 'Yes' on Grid
				user.migrationInfo = 'Yes';
			} else {
				// Display 'No' on Grid
				user.migrationInfo = 'No';
			}

			if (user.isRegistered) {
				// Display 'Yes' on Grid
				user.registrationInfo = 'Yes';
			} else {
				// Display 'No' on Grid
				user.registrationInfo = 'No';
			}

			if (user.lastLoginTime) {
				user.lastLoginReadableTime = this.dateTimeService.getDateTimeFromUnixTimestamp(user.lastLoginTime);
			}
			//Re-construct the NetClientPortal object because data is not being searchable by the
			// "Choose Portals to Migrate" transferbox-searchbox
			//TO DO: remove this re-contruction when bug is fixed.
			const userCorrected: NetClientPortal = {
				DisplayName: user.DisplayName,
				Login: user.Login,
				emailId: user.emailId,
				id: user.id,
				isAdmin: user.isAdmin,
				isDemoUser: user.isDemoUser,
				isRegistered: user.isRegistered,
				lastLoginReadableTime: user.lastLoginReadableTime,
				migrated: user.migrated,
				migrationInfo: user.migrationInfo,
				registrationInfo: user.registrationInfo,
				viewOnly: user.viewOnly
			};
			this.availablePortals.push(userCorrected);
		}
	}

	private createMigrationEventPayload(portalsToMigrate: any[]): Array<MigrationEventPayload> {
		const payLoadList: Array<MigrationEventPayload> = [];
		portalsToMigrate.forEach(portal => {
			const payload: MigrationEventPayload = new MigrationEventPayload(portal.id, portal.Login,
				portal.DisplayName, portal.emailId,
				portal.isRegistered);
			payLoadList.push(payload);
		});
		return payLoadList;
	}

	private postMigrationEvent() {
		const headers = new HttpHeaders({
			'Content-Type': 'application/json'
		});
		this.migrationService
			.post(this.postMigrationEventUrl, this.migrationEvent, headers)
			.pipe(
				catchError(error => {
					console.error(error);
					const errorMessage = `Failed Migration process, with the following error:<br>
																						<strong>${error}</strong>.<br>
																						Please try again later`;
					this.showError(errorMessage);
					this.showBusyloaderMigrateSelected = false;
					this.changeDetectorRef.markForCheck();
					return of();
				})
			)
			.subscribe((result: InitMigrationResponse) => {
				if (result) {
					// since the backend doesn't send payload for post migrate event,
					// use the payload that is source for this migration event
					this.migrationInprogress = InitMigrationResponse.createMigrationResultFromThis(result);
					this.migrationDetails.cacheAdditionallyMigrationResults(this.migrationSource, IN_PROGRESS, this.migrationInprogress);

					// migrate event posted
					this.hideTransferBox();
					this.showBusyloaderMigrateSelected = false;
					this.changeDetectorRef.markForCheck();
				} else {
					console.error('Invalid result when posting migration event');
				}
			});
	}

	async getSessionBindings() {
		const session = await this.getBindings();
		this.companyId = session.ApplicationConfiguration.CompanyId;
		const contactId = session.ApplicationConfiguration.ContactId;
		const meta = await this.getMeta();
		const bluemoonUserId = meta.PrismGuid;

		this.migrationEvent = {
			companyId: this.companyId,
			description: 'Netclient Document Migration',
			migrationSource: 'NetFirm',
			initiatorContactId: contactId,
			notificationRecipients: [meta.EmailAddress],
			bluemoonUserId,
			provisionTempStorage: false
		};
	}

	showError(message: string, type: string = 'danger') {
		this.alerts.push({
			type,
			msg: message,
			closeable: true
		});
	}

	private applyBoxOneGridFilterDefinition() {
		this.transferbox.boxOne.gridFilter.filterDefinition = `{
			"defaultFilterType": 3,
			"filters":[
				{
					"binding":"migrationInfo",
					"type":"value",
					"uniqueValues":null,
					"sortValues":true,
					"maxValues":250,
					"exclusiveValueSearch":true,
					"showValues":{"Yes":true, "No": false}
				},
				{
					"binding": "registrationInfo",
					"type": "value",
					"uniqueValues":null,
					"sortValues":true,
					"maxValues":250,
					"exclusiveValueSearch":true,
					"showValues":{"Yes":true, "No": false}
				}
			]
		}`;
	}

	private showTooltip(grid) {
		return (e: MouseEvent) => {
			const ht = grid.hitTest(e);
			const rng = null;
			if (!ht.range.equals(rng)) {
				if (ht.cellType === 1) { // cell type 1 = wjcGrid.CellType.Cell
					const cell = ht.panel.getCellElement(ht.row, ht.col);
					if (ht.target.scrollWidth >= ht.target.offsetWidth) {
						this.toolTip.show(ht.target, cell.innerHTML);
					}
				}
			}
		};
	}

	private hideTooltip() {
		return () => {
			this.toolTip.hide();
		};
	}

	private expandTransferboxToFullWidth(expand: boolean) {
		const sideNav = document.querySelector('bento-side-nav.migration-side-nav');
		const rightContainer = document.querySelector('div.migration-container-right');
		if (sideNav && rightContainer && this.netclientHeading) {
			if (expand) {
				// hide sidenav
				this.netclientHeading.nativeElement.classList.add('d-none');
				sideNav.classList.add('d-none');
				rightContainer.classList.add('col-12');

				// remove col-9 from the right side container of the side nav
				rightContainer.classList.remove('col-9');
			} else {
				// show sidenav
				sideNav.classList.remove('d-none');
				this.netclientHeading.nativeElement.classList.remove('d-none');

				// reset right side container with col-9
				rightContainer.classList.add('col-9');
				rightContainer.classList.remove('col-12');
			}
		}
	}
}

